import {
  Button,
  Checklist,
  Drawer,
  Field,
  Input,
  PowerSelect,
  Select
} from '@itds/elements/index.js';
import React, { useContext, useEffect, useState } from 'react';

import { AgencyContext } from '@brokerage/contexts/AgencyContext';
import { Api } from '@brokerage/utils/Api';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';

const AddMember = ({ members, onClose, onSave, show, currentAgencyMember = null }) => {
  const params = useParams();
  const { setNestedNewMember } = useContext(AgencyContext);
  const [data, setData] = useState({
    member: '',
    name: 'member',
    agency_id: params.agency_id,
    permissions: [],
    applicint_trusted_code: ''
  });

  useEffect(() => {
    setData({
      ...data,
      member: currentAgencyMember
    });
  }, [currentAgencyMember]);

  useEffect(() => {
    setData({
      member: '',
      name: 'member',
      agency_id: params.agency_id,
      permissions: [],
      applicint_trusted_code: ''
    });
  }, [show]);

  const handleInputChange = (name, e) => {
    const updated_data = { ...data, [name]: e.target.value };

    if (name === 'name' && e.target.value === 'admin') {
      updated_data.permissions = [];
    }

    setData(updated_data);
  };

  const handleMemberChange = member => {
    setData({ ...data, member });
  };

  const handlePermissionsChange = permissions => {
    setData({ ...data, permissions });
  };

  const handleSave = () => {
    if (data.member) {
      const { member, ...payload } = data;

      Api.saveMemberAgencyRole(null, { ...payload, member_id: member.value }).then(() => {
        onSave();
      });
    }
  };

  const handleNewMember = () => {
    onClose();
    setNestedNewMember(true);
  };

  return (
    <Drawer
      alignRight={true}
      footer={<Button onClick={handleSave}>Add To Agency</Button>}
      onClose={onClose}
      show={show}
      title='Add Member'
    >
      <Field label='Member'>
        <PowerSelect
          isMulti={false}
          onChange={handleMemberChange}
          options={members}
          value={data.member}
        />
        <br />
        <Button
          color='PRIMARY'
          onClick={handleNewMember.bind(null)}
          outline={true}
          small={true}
          style={{ float: 'right' }}
        >
          Create new member
        </Button>
      </Field>

      <Field label='Role'>
        <Select
          onChange={handleInputChange.bind(null, 'name')}
          options={[
            { value: 'member', label: 'Member' },
            { value: 'sales_rep', label: 'Sales Rep' },
            { value: 'admin', label: 'Admin' }
          ]}
          value={data.name}
        />
      </Field>
      {data.name !== 'admin' ? (
        <Field label='Permissions'>
          <Checklist
            onChange={handlePermissionsChange}
            options={[
              { value: 'billing', label: 'Billing' },
              { value: 'agency_forms', label: 'Agency Forms' },
              { value: 'notification_triggers', label: 'Notification Triggers' }
            ]}
            selected={data.permissions}
          />
        </Field>
      ) : null}
      <Field label='Applicint Trusted Code'>
        <Input
          onChange={handleInputChange.bind(null, 'applicint_trusted_code')}
          value={data.applicint_trusted_code}
        />
      </Field>
    </Drawer>
  );
};

AddMember.propTypes = {
  currentAgencyMember: PropTypes.object,
  members: PropTypes.array,
  onClose: PropTypes.func,
  onSave: PropTypes.func,
  show: PropTypes.bool
};

export default AddMember;
